/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMeal } from 'app/shared/model/meal.model';
import { INutritionIP } from 'app/shared/model/nutrition-ip.model';

export interface IMealNutrition {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  total?: number | null;
  rdi?: boolean | null;
  dailyTotal?: number | null;
  meal?: IMeal;
  nutrition?: INutritionIP;
}

export const defaultValue: Readonly<IMealNutrition> = {
  active: false,
  rdi: false,
};
